import React, {useContext} from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../../AppContext";
import "./Navbar.css";

export const Navbar = () => {
    const navigate = useNavigate();
    const { isLoggedIn, setIsLoggedIn, setUserID } = useContext(AppContext);

    const closeMenu = () => {
        const navbarCollapse = document.getElementById('navbarNav');
        if (navbarCollapse.classList.contains('show')) {
            document.querySelector('.navbar-toggler').click();
        }
    };

    const logout = () => {
        setIsLoggedIn(false);
        setUserID(null);
        closeMenu();
        navigate("/");
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: '#13294B' }}>
            <div className="container">
                <div className="navbar-brand-container">
                    <Link to="/">
                        <img
                            src="/subleazy_logo.jpg"
                            alt="Logo"
                            className="navbar-logo"
                        />
                    </Link>
                    <Link className="navbar-brand" to="/">UIUC Subleazy</Link>
                </div>
                <button 
                    className="navbar-toggler" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#navbarNav" 
                    aria-controls="navbarNav" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <div className="navbar-nav ms-auto">
                        <Link className="nav-item nav-link" to="/home" onClick={closeMenu}>Home</Link>                    
                        {!isLoggedIn ? (
                            <Link className="nav-item nav-link" to="/login" onClick={closeMenu}>Login/Register</Link>
                        ) : (
                            <>
                                <Link className="nav-item nav-link" to="/my-posts" onClick={closeMenu}>My Posts</Link>
                                <Link className="nav-item nav-link" to="/saved-posts" onClick={closeMenu}>Saved Posts</Link>
                                <Link className="nav-item nav-link" to="/new-post" onClick={closeMenu}>New Post</Link>
                                <button className="btn btn-outline-light ms-2" onClick={logout}>Logout</button>
                            </>                        
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};
